import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const Tab4HistoireMaladie = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));

  return (
    <div className="om-fields">

      <div className="om-field-group">
        <label>Date des premiers symptômes <ConfidenceLabel confidence={gc("date_premiers_symptomes")} /></label>
        <input type="date" value={form.date_premiers_symptomes ?? ""}
          onChange={(e) => onChange("date_premiers_symptomes", e.target.value)}
          style={{ borderColor: gc("date_premiers_symptomes").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Chronologie des signes <ConfidenceLabel confidence={gc("chronologie_signes")} /></label>
        <textarea rows={6} placeholder="Décrire la chronologie des signes cliniques..."
          value={form.chronologie_signes ?? ""}
          onChange={(e) => onChange("chronologie_signes", e.target.value)}
          style={{ borderColor: gc("chronologie_signes").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Les centres de santé consultés <ConfidenceLabel confidence={gc("centres_consultes")} /></label>
        <textarea rows={4} placeholder="Centres de santé consultés, avec dates..."
          value={form.centres_consultes ?? ""}
          onChange={(e) => onChange("centres_consultes", e.target.value)}
          style={{ borderColor: gc("centres_consultes").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Les examens réalisés et leurs conclusions(préciser les dates)  <ConfidenceLabel confidence={gc("examens_realises")} /></label>
        <textarea rows={5} placeholder="Examens réalisés et conclusions..."
          value={form.examens_realises ?? ""}
          onChange={(e) => onChange("examens_realises", e.target.value)}
          style={{ borderColor: gc("examens_realises").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Les traitements reçus <ConfidenceLabel confidence={gc("traitements_recus")} /></label>
        <textarea rows={4} placeholder="Traitements reçus avec dates..."
          value={form.traitements_recus ?? ""}
          onChange={(e) => onChange("traitements_recus", e.target.value)}
          style={{ borderColor: gc("traitements_recus").color || undefined }} />
      </div>

      <div className="om-field-group">
        <label>Préciser les traitements toujours en cours <ConfidenceLabel confidence={gc("traitements_en_cours")} /></label>
        <textarea rows={3} placeholder="Traitements en cours..."
          value={form.traitements_en_cours ?? ""}
          onChange={(e) => onChange("traitements_en_cours", e.target.value)}
          style={{ borderColor: gc("traitements_en_cours").color || undefined }} />
      </div>
    </div>
  );
};

export default Tab4HistoireMaladie;